// nullと空チェック
export function isNullOrEmpty(value: any): boolean {
  try {
    if (typeof value === "undefined") {
      return true;
    }
    if (value === null) {
      return true;
    }
    if (value === "") {
      return true;
    }
    if (value.length === 0) {
      return true;
    }
    return false;
  } catch (error) {
    return false;
  }
}

// 口座入力形式チェック
export function bankAccountNoCheck(param: any) {
  try {
    // 空文字でないかチェック
    if (isNullOrEmpty(param)) {
      return true;
    }
    // 数値で入力されているかチェック
    const num = Number(param);
    if (typeof num !== "number") {
      return true;
    }
    // 整数で入力されているかチェック
    const stringNum = String(param);
    if (stringNum.match(/[^0-9]+/)) {
      return true;
    }
    // 桁数が7以下かチェック
    if (stringNum.length && stringNum.length > 7) {
      return true;
    }
    return false;
  } catch (error) {
    console.error(error);
    return true;
  }
}
